<template>
  <IndicatorCard
    :loading="loading"
    :has-data="costs.length > 0"
    :is-result="isResult"
    :no-data-message="$t('Nenhum dado encontrado')"
    :title="title"
    :description="indicator.description"
    :excel-endpoint="indicator.excelEndpoint"
    :hide-excel="!isResult"
    :excel-loading="excelLoading"
    @export-excel="requestExcel"
  >
    <template #date-range>
      <DateRangePicker
        :start-date="startDate"
        :end-date="endDate"
        :disabled="isResult"
        @change="onDateRangeChange"
      />
    </template>

      <v-row class="ma-0" justify="center">
        <v-col cols="12">
          <strong>
            Custo total:
            {{ total ? total.toInstLocale() : '' }}
          </strong>

          <v-simple-table class="main-table" dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center"></th>
                  <th class="text-center">{{ $t('Fonte') }}</th>
                  <th class="text-center">{{ $t('Tipo') }}</th>
                  <th class="text-center">{{ $t('Nº O.S.') }}</th>
                  <th class="text-center">{{ $t('Setor') }}</th>
                  <th class="text-center">{{ $t('Equipamento padrão') }}</th>
                  <th class="text-center">{{ $t('Custo') }}</th>
                  <th class="text-center">{{ $t('Descrição') }}</th>
                  <th class="text-center">{{ $t('Natureza') }}</th>
                  <th class="text-center">{{ $t('Data') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="cost in costs" :key="cost.id">
                  <td class="text-center"></td>
                  <td class="text-center">{{ formatSource(cost.source) }}</td>
                  <td class="text-center">{{ formatType(cost.type) }}</td>
                  <td class="text-center">{{ cost.osNumber || '-' }}</td>
                  <td class="text-center">{{ cost.sector || '-' }}</td>
                  <td class="text-center">{{ cost.standardEquipment || '-' }}</td>
                  <td class="text-center">{{ formatCost(cost.cost) }}</td>
                  <td class="text-center">{{ cost.description || '-' }}</td>
                  <td class="text-center">{{ cost.nature || '-' }}</td>
                  <td class="text-center">{{ formatDate(cost.date) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div class="pagination" v-if="!filterProp.data">
            <div class="item-pagination block-two">
              <v-pagination
                class="pagination-item"
                v-model="page"
                :length="totalPages"
                :total-visible="9"
              ></v-pagination>
            </div>
          </div>
        </v-col>
      </v-row>

    <template #review>
    

    <v-row class="ma-0">
      <v-col cols="12" v-if="isResult && review">
        <strong>{{ $t('Análise crítica') }}</strong>
        <p v-html="review"></p>
      </v-col>
      <v-col cols="12" v-else-if="!isResult">
        <tiptap-vuetify
          v-model="filter.review"
          :extensions="extensions"
          :label="$t('Análise crítica')"
          :placeholder="
            $t('Digite sua análise crítica para o indicador abaixo')
          "
          :card-props="{ flat: true, outlined: true, rounded: true }"
          class="primary-input"
          outlined
          dense
          hide-details="auto"
        ></tiptap-vuetify>
      </v-col>
    </v-row>
    </template>
  </IndicatorCard>
</template>

<script>
import { getIndicatorById } from '../../../../../indicators/indicatorRegistry'
import ApiService from '../../../../../../../../services/ApiService'
import moment from 'moment'
import Utils from '../../../../../../../../Utils/FormatDate'
import IndicatorCard from '../../shared/IndicatorCard.vue'
import DateRangePicker from '../../shared/DateRangePicker.vue'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'

export default {
  name: 'AvoidedCosts',

  props: {
    title: { type: String, default: '' },
    apiEndpointOverride: { type: String, default: '' },
    snapshotData: { type: Object, default: null },
    filterProp: Object,
    institution: Object,
    unidades: Array,
    isResult: { type: Boolean, default: false },
    review: String,
  },

  components: {
    IndicatorCard,
    DateRangePicker,
    TiptapVuetify,
  },

  created() {
    this.filter.institutionId = this.institution.id
    this.filter.unidadeIds = this.unidades

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    if (this.filterProp) {
      this.filter = this.filterProp
      this.startDate = moment(this.filter.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.endDate = moment(this.filter.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    }

    this.list()
  },

  data() {
    return {
      excelLoading: false,
      startDate: '',
      endDate: '',
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      filter: {
        page: 1,
        pageSize: 7,
        institutionId: null,
        unidadeIds: [],
        startDate: null,
        endDate: null,
        review: '',
      },
      apiService: new ApiService(),
      costs: [],
      total: 0,
      loading: true,
      page: 1,
      totalPages: 1,
    }
  },
  computed: {
    indicator() {
      return getIndicatorById('avoided_costs') || {}
    },
  },


  methods: {
    onDateRangeChange({ startDate, endDate }) {
      this.startDate = startDate
      this.endDate = endDate
      this.filter.page = 1
      this.page = 1
      this.filterProp.data = null
      this.list()
    },

    requestExcel() {
      if (!this.indicator.excelEndpoint) return
      this.excelLoading = true
      const filename = `${this.indicator.legacyKey}.xlsx`
      this.apiService
        .post(this.indicator.excelEndpoint, { ...this.filter, pageSize: 999999 })
        .then((response) => {
          const data = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = data
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .finally(() => {
          this.excelLoading = false
        })
    },

    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },
    formatDate(date) {
      return Utils.dateTime(date)
    },

    setInfos() {
      const model = {
        chart: getIndicatorById('avoided_costs').legacyKey,
        ...this.filter,
        data: null,
      }
      this.$emit('setInfos', model)
    },

    formatSource(source) {
      if (source === 'AvoidedCost') return 'Cadastro Manual'
      if (source === 'ServiceOrderCost') return 'Ordem de Serviço'
      return source || '-'
    },

    formatType(type) {
      if (type === 'Recurrent') return 'Recorrente'
      if (type === 'Unitary') return 'Unitário'
      return type || '-'
    },

    formatCost(value) {
      if (value == null) return 'R$ 0,00'
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value)
    },

    async list() {
      this.loading = true
      try {
        if (this.filterProp.data) {
        const response = JSON.parse(this.filterProp.data)
        this.costs = response.content.model.objects
        this.total = response.content.total

        this.totalPages = response.content.model.pager.totalPages
        return
        }

        if (!this.isResult) this.setDates()
        this.filter.institutionId = this.institution.id
        this.filter.pageSize = 7
        this.filter.unidadeIds = this.unidades
        const response = await this.apiService.post(
        this.apiEndpointOverride || 'reports/listAvoidedCosts', this.filter
        )
        this.costs = response.content.model.objects
        this.total = response.content.total
        this.totalPages = response.content.model.pager.totalPages
      } finally {
        this.loading = false
      }
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },

    filter: {
      deep: true,
      handler() {
        this.setInfos()
      },
    },
  },
}
</script>

<style scoped></style>
